import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import DashboardHeader from "../Dashboard/DashboardHeader";
import { baseapi } from "../Environmentalurl";
import {
  ApplicationType,
  entity_id,
  getGeolocation,
  locationGeo,
  orderID,
  Platform,
} from "../Utils/Const";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function TransferAmount() {
  const navigate = useNavigate();
  const location = useLocation();
  const beneficiary = location.state?.beneficiary;
  const ip = useIPAddress();
  // ===== LOGIC STATE ONLY =====
  const [amount, setAmount] = useState("");
  const [tpin, setTpin] = useState("");
  const [openTpin, setOpenTpin] = useState(false);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);

  // ================= PROCEED =================
  const handleProceed = () => {
    if (!amount || Number(amount) <= 0) {
      alert("Enter valid amount");
      return;
    }
    setOpenTpin(true);
  };

  // ================= IMPS API =================
  const handleIMPS = async () => {
    try {
      setLoading(true);

      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_IMPS",
        Statement: "IFSC",
        ServiceID: "9",

        ApplicationType: ApplicationType,
        Platform: Platform,
        EntityID: entity_id,

        SessionID: sessionStorage.getItem("SessionID"),
        Mobilenumber: sessionStorage.getItem("mobileNumber"),

        Sender_Name: sessionStorage.getItem("userName") || "",
        Sender_MMID: "",
        Sender_VirtualAccountNumber: "",

        BeneficiaryName: beneficiary.name,
        BeneficiaryBank: beneficiary.bank,
        BeneficiaryAccountNumber: beneficiary.acc,
        BeneficiaryIFSC: beneficiary.ifsc,
        BeneficiaryMobileNumber: beneficiary.mobile || "",

        Customer_Mobile_No: sessionStorage.getItem("mobileNumber"),

        TrxnAmount: Number(amount),
        Narration: `IMPS Transfer using IFSC of Rs.${amount} to ${beneficiary.name}`,

        OrderID: orderID,
        TPIN: tpin,

        GeoLocation: locationGeo,
        MachineID: ip,
        PublicIP: "106.78.1.23",
        PrivateIP: "106.78.1.23",

        PANNumber: "",

        BrowserName: "",
        BrowserVersion: "",
        Device_Make: "",
        Device_Model: "",
        Device_SerialNo: "",
        IMEI: "",
        OSName: "",
        OSVersion: "",

        Optional1: "",
        Optional2: "",
        Optional3: "",
        Optional4: "",
        Optional5: "",
        Optional6: "",
        TimeZone: null,
      };

      const res = await api.post(`${baseapi}/JanAadhaareWalletIMPS`, payload);

      if (res.data?.Response_Code === "1000") {
        alert("IMPS Transfer Successful");
        navigate("/dashboard/transfertobank");
      } else {
        alert(res.data?.Message || "IMPS Failed");
      }
    } catch (err) {
      console.error(err);
      alert("IMPS Transfer Failed");
    } finally {
      setLoading(false);
      setOpenTpin(false);
    }
  };

  return (
    <>
      <DashboardHeader />

      {/* ===== YOUR DESIGN – NOT CHANGED ===== */}
      <Box bgcolor="#f6fafc" minHeight="100vh">
        <Box maxWidth="600px" mx="auto" py={5}>
          <Paper sx={{ p: 4, borderRadius: 3 }}>
            <Typography fontWeight="bold" mb={2}>
              Transfer Amount
            </Typography>

            <Typography fontSize={13} fontWeight={600}>
              Beneficiary
            </Typography>
            <Typography mb={2}>
              {beneficiary.name} • {beneficiary.bank}
            </Typography>

            <Typography fontSize={13} fontWeight={600}>
              ENTER AMOUNT
            </Typography>
            <TextField
              fullWidth
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="₹ Enter amount"
              sx={{ mt: 1 }}
            />

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 4, bgcolor: "#22c55e" }}
              onClick={handleProceed}
            >
              Proceed
            </Button>
          </Paper>
        </Box>
      </Box>

      {/* ===== TPIN POPUP (ONLY LOGIC) ===== */}
      <Dialog open={openTpin} onClose={() => setOpenTpin(false)}>
        <DialogTitle>Enter TPIN</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center" }}>
            {[0, 1, 2, 3].map((index) => (
              <TextField
                key={index}
                type="password"
                value={tpin[index] || ""}
                inputRef={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(-1);

                  const arr = tpin.split("");
                  arr[index] = value;

                  setTpin(arr.join(""));

                  if (value && index < 3) {
                    inputRefs.current[index + 1]?.focus();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace" && !tpin[index] && index > 0) {
                    inputRefs.current[index - 1]?.focus();
                  }
                }}
                inputProps={{
                  maxLength: 1,
                  inputMode: "numeric",
                  style: {
                    textAlign: "center",
                    fontSize: "22px",
                    fontWeight: 600,
                  },
                }}
                sx={{
                  width: 60,
                  "& .MuiOutlinedInput-root": {
                    height: 60,
                    borderRadius: "12px",
                  },
                }}
              />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTpin(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={tpin.length !== 4 || loading}
            onClick={handleIMPS}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
